export const BrowserChecker = {
    isSafari() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }
};

export function getBrowserInfos() {
    var ua = navigator.userAgent;
    var tem;
    var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {
            name: 'IE',
            version: parseFloat((tem[1] || '')),
        };
    }
    
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/);
        if (tem != null) {
            return {
                name: 'Opera',
                version: parseFloat(tem[1]),
            };
        }
    
        tem = ua.match(/\bEdge\/(\d+)/);
        if (tem != null) {
            return {
                name: 'Edge',
                version: parseFloat(tem[1]),
            };
        }
    }
    
    M = M[2] ? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
    
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
    }
    
    return {
        name: M[0],
        version: parseFloat(M[1]),
    };
}